import { makeStyles } from '@material-ui/core/styles';
import { hexToRgba } from '../../../common/formatters/colorFormatter';
import creationModeEnum from '../../../finding/models/creationModeEnum';

export const baseIcon = {
  fontSize: '30px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

const useStyles = makeStyles((theme) => ({
  findingImageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: hexToRgba(theme.palette.secondary.main, 0.3),
    color: theme.palette.primary.main,
    height: '12rem',
    width: '15rem',
  },
  classificationImage: {
    height: '10rem',
    width: '10rem',
  },
  immediateIcon: {
    ...baseIcon,
    color: theme.palette.findingType.immediate,
  },
  investigateIcon: {
    ...baseIcon,
    color: theme.palette.findingType.investigation,
  },
  noteIcon: ({ creationMode }) => ({
    ...baseIcon,
    color: creationMode === creationModeEnum.automatic ? theme.palette.findingType.noteAutomatic : theme.palette.findingType.noteManual,
  }),
  dismissedIcon: {
    ...baseIcon,
    color: theme.palette.findingType.dismissed,
  },
  unclassifiedIcon: {
    ...baseIcon,
    color: theme.palette.findingType.unclassified,
  },
  popupContent: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '-0.5rem',
  },
  sentAt: {
    fontSize: '0.75rem',
    fontStyle: 'italic',
    display: 'flex',
    justifyContent: 'flex-end',
    color: theme.palette.text.alternate,
  },
  label: {
    fontSize: '0.75rem',
    display: 'flex',
    justifyContent: 'flex-end',
    fontWeight: 600,
    marginTop: '0.4rem',
  },
}));

export default useStyles;
